import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import './styles.scss';

export default function InputDateTime({
  className,
  classNameFull,
  titleDate,
  titleTime,
  idDate,
  idTime,
  style,
  date,
  onDateChange,
  wrapped,
  isShowDate,
  isShowTime,
  dateClassName,
  timeClassName,
  dateClassWrapperName,
  timeClassWrapperName,
  isShowDateWrapper,
  isShowTimeWrapper,
  dateFormat,
  errorText,
  disabled,
  minDate,
  maxDate,
}) {
  function renderDateComponent() {
    if (isShowDate) {
      return (
        <div className="d-flex flex-column calendar">
          <DatePicker
            selected={date}
            className={`${dateClassName} ${errorText && 'error-input'}`}
            id={idDate}
            dateFormat={dateFormat}
            onChange={(date) => onDateChange(date)}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
          />
          {errorText && <p className="text-danger text-error">{errorText}</p>}
        </div>
      );
    }
    return null;
  }

  function renderTimeComponent() {
    if (isShowTime) {
      return (
        <div>
          <DatePicker
            selected={date}
            dateFormat="h:mm aa"
            showTimeSelect
            timeIntervals={1}
            showTimeSelectOnly
            className={timeClassName}
            id={idTime}
            timeCaption="Time"
            onChange={(date) => onDateChange(date)}
            disabled={disabled}
            minDate={minDate}
            maxDate={maxDate}
          />
          {errorText && <p className="text-danger text-error text-center">{errorText}</p>}
        </div>
      );
    }
    return null;
  }

  if (wrapped) {
    return (
      <div className={classNameFull ? classNameFull : `row ${className}`} style={style}>
        {isShowDateWrapper && (
          <div className={dateClassWrapperName}>
            <label htmlFor={idDate} className="form-label">
              {titleDate}
            </label>
            {renderDateComponent()}
          </div>
        )}
        {isShowTimeWrapper && (
          <div className={timeClassWrapperName}>
            <label htmlFor={idTime} className="form-label">
              {titleTime}
            </label>
            {renderTimeComponent()}
          </div>
        )}
      </div>
    );
  }
  return (
    <>
      {renderDateComponent()}
      {renderTimeComponent()}
    </>
  );
}

InputDateTime.defaultProps = {
  className: '',
  classNameFull: '',
  idDate: '',
  idTime: '',
  titleDate: '',
  titleTime: '',
  style: {},
  date: null,
  wrapped: true,
  isShowDate: true,
  isShowTime: true,
  dateClassName: 'form-control',
  onDateChange: () => {},
  timeClassName: 'form-control',
  dateClassWrapperName: 'col-8',
  timeClassWrapperName: 'col-4',
  isShowDateWrapper: true,
  isShowTimeWrapper: true,
  dateFormat: 'dd MMMM yyyy',
  errorText: '',
  disabled: false,
};

InputDateTime.propTypes = {
  className: PropTypes.string,
  classNameFull: PropTypes.string,
  idDate: PropTypes.string,
  titleDate: PropTypes.string,
  idTime: PropTypes.string,
  titleTime: PropTypes.string,
  style: PropTypes.objectOf(Object),
  date: PropTypes.objectOf(Date),
  onDateChange: PropTypes.func,
  wrapped: PropTypes.bool,
  isShowDate: PropTypes.bool,
  isShowTime: PropTypes.bool,
  dateClassName: PropTypes.string,
  timeClassName: PropTypes.string,
  dateClassWrapperName: PropTypes.string,
  timeClassWrapperName: PropTypes.string,
  isShowDateWrapper: PropTypes.bool,
  isShowTimeWrapper: PropTypes.bool,
  dateFormat: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};
